import { ObjectPlugin } from "vue";

const utilsPlugin = () => {
  return {
    print(value: any) {
      console.log("print", value);
      return value;
    },
    initArray(size: number, value = 0) {
      const array = [];
      for (let ii = 0; ii < size; ii++) {
        array[ii] = value;
      }

      return array;
    },
    round(value: string | number | null, dec: number = 2) {
      if (value === null || value === "") return "";
      const testValue = typeof value === "string" ? parseInt(value) : value;

      if (isNaN(testValue)) return value;
      value = testValue as number;

      let strVal = value.toFixed(dec);

      let pad = 0;

      if (dec === 0) {
        /* empty */
      } else if (!strVal.includes(".")) {
        strVal += ".";
        pad = dec;
      } else {
        pad = dec - strVal.split(".")[1].length;
      }

      for (let ii = 0; ii < pad; ii++) {
        strVal += "0";
      }

      return strVal;
    },
    // No i did not write this, and yes i got it from google :)
    adjustColor(col: string, amt: number) {
      let usePound = false;

      if (col[0] === "#") {
        col = col.slice(1);
        usePound = true;
      }

      const num = parseInt(col, 16);

      let r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      let b = ((num >> 8) & 255) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      let g = (num & 255) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
    between(start: number, val: number, end: number) {
      return start <= val && val <= end;
    },
    async importCSV(file: File) {
      let data = [];
      const mainHeaders = [];
      const fileString = await file.text();
      const array = fileString.split("\r");
      const result = [];
      const headers = array[0].split(",");
      for (const i in headers) {
        mainHeaders.push({
          text: headers[i],
          value: headers[i],
        });
      }

      for (let i = 1; i < array.length - 1; i++) {
        const obj: Record<string, string[] | string> = {};
        const str = array[i];
        let s = "";

        let flag = 0;
        for (let ch of str) {
          if (ch === '"' && flag === 0) {
            flag = 1;
          } else if (ch === '"' && flag === 1) flag = 0;
          if (ch === "," && flag === 0) ch = "|";
          if (ch !== '"') s += ch;
        }

        const properties = s.split("|");

        for (const j in headers) {
          if (properties[j].includes(", ")) {
            obj[headers[j]] = properties[j]
              .split(", ")
              .map((item) => item.trim());
          } else obj[headers[j]] = properties[j];
        }

        result.push(obj);
      }
      data = result;

      return { data, mainHeaders };
    },
  } as const;
};

export type UtilsPlugin = ReturnType<typeof utilsPlugin>;

export const $utils: ObjectPlugin = {
  install: (app, _) => {
    app.config.globalProperties.$utils = utilsPlugin();
  },
};

export default $utils;
